import { isProductEnabled } from "@/business/product-access";
import { useConnectQuickbooks } from "@/business/use-connect-quickbooks";
import { useBusiness } from "@/core/business";
import { useBusinessProducts } from "@/core/business/use-business-products";
import { useGetMyUser } from "@/user/query";
import { canManageFinances } from "@/user/utils";

export const useQuickbooksConnect = () => {
  const { data: userInfo } = useGetMyUser();
  const { businessId, selectedBusiness } = useBusiness();
  const { settings } = useBusinessProducts();
  const { connect, isPending } = useConnectQuickbooks(businessId);

  return {
    show:
      isProductEnabled(settings, "accounts_payable") &&
      !!selectedBusiness?.service_titan_enabled &&
      canManageFinances(userInfo),
    isConnected: !!selectedBusiness?.quickbooks_connected,
    isPending,
    connect,
  };
};
